import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CategoryService } from '@shared/service/http_services/category.service';
import { AppStateService } from '@app/state/app-state.service';
import { exhaustMap, map, of } from 'rxjs';

export const mainDataResolver: ResolveFn<boolean> = () => {
  const appState = inject(AppStateService);
  const categoryService = inject(CategoryService);

  return appState.categories$.pipe(
    exhaustMap(res => (res?.length > 0) ? of(true) : categoryService.getAllCategories().pipe(
      map(res => {
        appState.categories$ = res?.hasError ? [] : res?.result;
        return true;
      })
    )
    )
  );

};
